import { FeatureFlag } from '../FeatureFlag';

export const enableLabRiskSettings = new FeatureFlag({
    key: 'enable-lab-risk-settings',
    defaultValue: false,
});
